export const LANGS = [
  { code: "DE", slug: "de", de: "Deutsch", en: "German", tagDe: "Aktuelle Sets und Klassiker auf Deutsch.", tagEn: "Current sets and classics in German.", avatar: "av4" },
  { code: "EN", slug: "en", de: "Englisch", en: "English", tagDe: "Internationale Sets und beliebte Releases.", tagEn: "International sets and popular releases.", avatar: "av2" },
  { code: "JA", slug: "ja", de: "Japanisch", en: "Japanese", tagDe: "Exklusive Sets und besondere Illustrationen.", tagEn: "Exclusive sets and special illustrations.", avatar: "av3" },
  { code: "ZH-CN", slug: "zh-cn", de: "Chinesisch (vereinfacht)", en: "Simplified Chinese", tagDe: "Moderne Sets aus China.", tagEn: "Modern sets from China.", avatar: "av11" },
  { code: "ZH-TW", slug: "zh-tw", de: "Chinesisch (traditionell)", en: "Traditional Chinese", tagDe: "Beliebte Sets und exklusive Releases.", tagEn: "Popular sets and exclusive releases.", avatar: "av16" },
  { code: "KO", slug: "ko", de: "Koreanisch", en: "Korean", tagDe: "Moderne Sets zu attraktiven Preisen.", tagEn: "Modern sets at great prices.", avatar: "av5" },
];

export const langByCode = (c) => LANGS.find((l) => l.code === c);
export const langBySlug = (s) => LANGS.find((l) => l.slug === (s || "").toLowerCase());
export const langName = (c, lang) => { const l = langByCode(c); return l ? (lang === "en" ? l.en : l.de) : ""; };

export const AVAIL = {
  in_stock: ["Auf Lager – sofort versandbereit", "In stock – ships now", "#2E9E6B"],
  limited: ["Nur noch wenige verfügbar", "Limited stock", "#B8860B"],
  preorder: ["Vorbestellung", "Pre-order", "#6E3FB8"],
  out_of_stock: ["Ausverkauft", "Sold out", "#707783"],
};

export const availabilityOf = (p) => p.availability_status || (p.preorder ? "preorder" : p.stock <= 0 ? "out_of_stock" : p.stock <= 3 ? "limited" : "in_stock");

export const conditionLabel = (p, lang) => {
  if (p.sealed && /sealed|neu/i.test(p.condition || "Sealed")) return lang === "en" ? "New & factory sealed" : "Neu & originalversiegelt";
  return p.condition || "–";
};

export const contentsLabel = (p, lang) => p.contents || (p.pack_count ? `${p.pack_count} ${lang === "en" ? "booster packs" : "Boosterpacks"}` : "");
